module.exports = __webpack_public_path__ + "static/media/zhuanhuan.a3604208.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/zhuanhuan.png
// module id = 1904
// module chunks = 0